import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function UnbreakableIllustration({
  achievementId,
  variant = 'blaze',
  // Unbreakable unlocks blaze
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3729">
      <div className="relative w-full h-full bg-gradient-to-br from-cyan-300 to-blue-600 overflow-hidden" data-id="element-3730">
        {/* Background: Crystal Cave */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3731">
          {/* Background crystals */}
          <path d="M20 200 L40 100 L60 200 Z" fill="#67E8F9" opacity="0.6" data-id="element-3732" />
          <path d="M140 200 L170 80 L200 200 Z" fill="#22D3EE" opacity="0.5" data-id="element-3733" />
          <path d="M-10 150 L20 60 L50 150 Z" fill="#06B6D4" opacity="0.4" data-id="element-3734" />

          {/* Top crystals */}
          <path d="M80 0 L100 60 L120 0 Z" fill="#A5F3FC" opacity="0.7" data-id="element-3735" />
          <path d="M130 0 L150 40 L170 0 Z" fill="#CFFAFE" opacity="0.6" data-id="element-3736" />
          <path d="M30 0 L50 50 L70 0 Z" fill="#67E8F9" opacity="0.5" data-id="element-3737" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[10%]" data-id="element-3738">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-3739">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'proud' : 'thinking'} variant={variant} accessory="doubleFlameCrown" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3740" />
          </div>
        </div>

        {/* Foreground: Floating Crystal Shards */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3741">
            <path d="M30 80 L40 70 L45 85 L35 95 Z" fill="#FFFFFF" opacity="0.8" data-id="element-3742" />
            <path d="M160 120 L170 105 L180 115 L165 130 Z" fill="#CFFAFE" opacity="0.9" data-id="element-3743" />
            <path d="M140 50 L145 45 L150 55 L142 60 Z" fill="#FFFFFF" opacity="0.7" data-id="element-3744" />
            <path d="M50 140 L60 130 L65 145 L55 155 Z" fill="#A5F3FC" opacity="0.8" data-id="element-3745" />

            {/* Glints */}
            <path d="M35 75 L45 75 M40 70 L40 80" stroke="white" strokeWidth="1.5" data-id="element-3746" />
            <path d="M170 110 L180 110 M175 105 L175 115" stroke="white" strokeWidth="1.5" data-id="element-3747" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}